import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Button from 'core/modules/atoms/Button';
import InappropriateUseCard from './InappropriateUseCard/InappropriateUseCard';
import './_inappropriate-use-section.scss';
import useInappropriateUseSection from './useInappropriateUseSection';

type InappropriateUseSectionProps = {
  allCourseIds: string[];
  classValue: string;
  groupCourseMap: Record<string, string[]>;
  timePeriodValue: string;
};

function InappropriateUseSection({ allCourseIds, classValue, groupCourseMap, timePeriodValue }: InappropriateUseSectionProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const history = useHistory();
  const { handleMarkAllAsAttended, markingAll, messages, total, loading } = useInappropriateUseSection({
    allCourseIds,
    classValue,
    groupCourseMap,
    timePeriodValue,
  });

  const hasPendingAnnotations = messages.some((msg) => msg.annotationStatus === 'PENDING');

  if (loading || total === 0) {
    return null;
  }

  return (
    <div className="inappropriate-use-section">
      <div className="inappropriate-use-section__header">
        <div className="inappropriate-use-section__header-titles">
          <h2 className="inappropriate-use-section__title">{t('chatbot:ai_analytics_inappropriate_use_title')}</h2>
          <p className="inappropriate-use-section__subtitle">{t('chatbot:ai_analytics_inappropriate_use_subtitle', { count: total })}</p>
        </div>
        {total > 0 && (
          <div className="inappropriate-use-section__header-actions">
            {hasPendingAnnotations && (
              <Button color="transparent-primary" disabled={markingAll} onClick={handleMarkAllAsAttended} size="xs" text={t('chatbot:ai_analytics_inappropriate_use_mark_all')} type="button" variant="inline" />
            )}
            <Button
              text={t('chatbot:ai_analytics_inappropriate_use_view_all', { count: total })}
              variant="outline"
              color="primary-outlined"
              size="xs"
              onClick={() => history.push(`/analytics/flagged-messages?class=${classValue}&period=${timePeriodValue}`)}
              type="button"
            />
          </div>
        )}
      </div>

      {messages.length > 0 && (
        <div className="inappropriate-use-section__cards">
          {messages.map((message) => (
            <InappropriateUseCard key={message.annotationId} message={message} />
          ))}
        </div>
      )}
    </div>
  );
}

export default InappropriateUseSection;
